'use client';

import { c as _c } from "react/compiler-runtime";
import TooltipPlain, { Props as TooltipPlainProps } from '../TooltipPlain';
import TooltipRich, { Props as TooltipRichProps } from '../TooltipRich';
export type Props = ({
  variant?: 'plain';
} & TooltipPlainProps) | ({
  variant: 'rich';
} & TooltipRichProps);
const Tooltip = t0 => {
  const $ = _c(7);
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
  } else {
    otherProps = $[1];
    t1 = $[2];
  }
  const variant = t1 === undefined ? "plain" : t1;
  if (variant === "rich") {
    const t2 = otherProps as TooltipRichProps;
    let t3;
    if ($[3] !== t2) {
      t3 = <TooltipRich {...t2} />;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t2 = otherProps as TooltipPlainProps;
  let t3;
  if ($[5] !== t2) {
    t3 = <TooltipPlain {...t2} />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default Tooltip;